module.exports = __webpack_public_path__ + "img/main-slider-1.png";